import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react'

import './styles.scss'

import GoogleLogo from '../../../../static/images/google-icon.svg'

type SharedProps = {
  size?: 'sm' | 'lg'
  className?: string
}

export type GoogleLoginButtonProps = SharedProps &
  (
    | (Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'size'> & { href?: undefined })
    | (Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'size'> & { href: string })
  )

const GoogleLoginButton = ({ size = 'lg', className, ...props }: GoogleLoginButtonProps) => {
  const classes = ['google-login-button', `google-login-button--${size}`, className].filter(Boolean).join(' ')
  const content = (
    <div className='d-flex align-items-center'>
      <img src={GoogleLogo} className='icon' alt='google login' />
      <span className='buttonText w-100'>Continue with Google</span>
    </div>
  )

  if ('href' in props && props.href) {
    const { href, ...anchorProps } = props
    return (
      <a href={href} className={classes} {...anchorProps}>
        {content}
      </a>
    )
  }

  const { type = 'button', ...buttonProps } = props as ButtonHTMLAttributes<HTMLButtonElement>
  return (
    <button type={type} className={classes} {...buttonProps}>
      {content}
    </button>
  )
}

export default GoogleLoginButton
